export default __webpack_public_path__ + "static/media/visual_02.a8dfe4e9.png";